module.exports = __webpack_public_path__ + "static/media/facebook25.754f3a1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/facebook25.svg
// module id = 547
// module chunks = 0